import { render } from "./IMIVVitaminTherapiesContentEn.vue?vue&type=template&id=4674b9f2&scoped=true"
import script from "./IMIVVitaminTherapiesContentEn.vue?vue&type=script&lang=js"
export * from "./IMIVVitaminTherapiesContentEn.vue?vue&type=script&lang=js"

import "./IMIVVitaminTherapiesContentEn.vue?vue&type=style&index=0&id=4674b9f2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4674b9f2"]])

export default __exports__